import { BrandName } from 'src/@enums'

export interface IMagazinePinProductItem {
  sku: string
  name?: string
  images?: string[]
  price?: number
  salePrice?: number
}

export enum PinType {
  PIN = 'pin',
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export interface IPinLinkMetadataBase {
  height: string
  width: string
}

export interface IPinMetadataProduct {
  size?: number
  height?: string
  width?: string
  items: IMagazinePinProductItem[]
}

export interface IPinMetadataLinkInternal extends IPinLinkMetadataBase {
  link: {
    pageId: number
  }
}

export interface IPinMetadataLinkExternal extends IPinLinkMetadataBase {
  link: {
    url: string
    description?: string
  }
}

export interface IPinBase {
  id: string
  x: string
  y: string
  sku?: string
  pageId: number
}

export type IPin = IPinProduct | IPinLinkExternal | IPinLinkInternal

export interface IPinProduct extends IPinBase {
  pinType: PinType.PIN
  metadata: IPinMetadataProduct
}

export interface IPinLinkExternal extends IPinBase {
  pinType: PinType.EXTERNAL
  metadata: IPinMetadataLinkExternal
}

export interface IPinLinkInternal extends IPinBase {
  pinType: PinType.INTERNAL
  metadata: IPinMetadataLinkInternal
}

export interface PinIconOptimizeId extends Record<BrandName, string> {}
